import BaseMap from "../../shared/components/BaseMap";
import { Geo } from "../../../../public/admin/scripts/messages/address_component";
import { Box, Image, Button } from "@chakra-ui/react";
import MapMarkerIcon from "../../shared/icons/MapMarkerIcon";
import { MapRef, Marker } from "react-map-gl/maplibre";
import HomeIcon from "../../shared/icons/HomeIcon";
import React from "react";

interface Props {
  caregiverMarkers: {
    addressGeoLocation: Geo;
    photoUrl: string | null;
  }[];
  patientMarker: Geo;
  onClickHome: (marker: Geo) => void;
}

const PatientTaskMetricsMap = React.forwardRef<MapRef, Props>((props, ref) => {
  const handleClickHome = () => {
    props.onClickHome(props.patientMarker);
  };

  return (
    <Box height="100%" width="100%">
      <BaseMap ref={ref} destination={props.patientMarker} style={{ width: "100%", height: 700 }}>
        {/* Patient marker */}
        <Marker latitude={props.patientMarker.lat} longitude={props.patientMarker.lng}>
          <MapMarkerIcon color="blue.400" height={20} width={20} />
        </Marker>
        {/* Caregiver markers */}
        {props.caregiverMarkers.map((marker, idx) => (
          <CaregiverPositionMapMarker
            key={marker.addressGeoLocation.lat + "-" + marker.addressGeoLocation.lng + "-" + idx}
            photoUrl={marker.photoUrl}
            position={marker.addressGeoLocation}
          />
        ))}

        {/* Reset to patient button */}
        <Button boxShadow="md" colorScheme="blue" margin={4} onClick={handleClickHome}>
          <HomeIcon />
        </Button>
      </BaseMap>
    </Box>
  );
});

PatientTaskMetricsMap.displayName = "PatientTaskMetricsMap";

export default PatientTaskMetricsMap;

export const CaregiverPositionMapMarker = (props: { position: Geo; photoUrl: string | null }) => {
  return (
    <Marker anchor="bottom" latitude={props.position.lat} longitude={props.position.lng}>
      <Box alignItems="center" display="flex" flexDirection="column" position="relative">
        <Image
          alt="Caregiver"
          bg="blue.400"
          border="2px solid"
          borderColor="blue.400"
          borderRadius="50%"
          boxShadow="0 0 4px rgba(0,0,0,0.2)"
          height={20}
          objectFit="cover"
          src={props.photoUrl ?? "/admin/images/blank-profile.jpg"}
          width={20}
        />
        {/* Triangle pointer */}
        <Box
          borderLeft="10px solid transparent"
          borderRight="10px solid transparent"
          borderTop="14px solid"
          borderTopColor="blue.400"
          height="0"
          marginTop="-2px"
          width="0"
          zIndex={1}
        />
      </Box>
    </Marker>
  );
};
